import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
// TODO Remove after running GOSU-0001
import { useState } from 'react';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import Gosu0001FreeCRMModalIframe from '../step-iframe-demo-tour/Gosu0001FreeCRMModalIframe';
import { useTracker } from '../tracking/useTracker';

const HubInterestMessageFooter = ({
  messageKey
}) => {
  const Tracker = useTracker();
  const [shouldShowDemo, setShouldShowDemo] = useState(false);

  const changeDemoVisibility = () => {
    setShouldShowDemo(!shouldShowDemo);
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [shouldShowDemo && /*#__PURE__*/_jsx(Gosu0001FreeCRMModalIframe, {
      onClose: changeDemoVisibility
    }), /*#__PURE__*/_jsx(FormattedJSXMessage, {
      elements: {
        Link: UILink
      },
      message: `message.${messageKey}.footer_jsx`,
      options: {
        use: 'on-bright',
        onClick: () => {
          Tracker.signupInteraction('click-demo-link');
          changeDemoVisibility();
        }
      }
    })]
  });
};

export default HubInterestMessageFooter;